export default "__VITE_ASSET__CqLBGrc4__"